import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "modal d-block modalBackground" };
const _hoisted_2 = {
    class: "modal-dialog modal-dialog-centered",
    role: "document"
};
const _hoisted_3 = { class: "px-sm-4 px-2 disableAccessAsModal position-relative modal-content border-0" };
const _hoisted_4 = { class: "border-0 d-flex gap-3 justify-content-center modal-footer" };
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DisableAccessAsModal',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();
        const commumAccessRoles = ['student', 'tutor', 'teacher'];
        const managementAccessRoles = ['manager', 'supervisor', 'client'];
        const userRole = computed(() => store.getters.getType);
        const returnToLogin = async () => {
            await store.dispatch('resetUserDataUserModule');
            await closeModal();
            router.push({ name: 'Login' });
        };
        const redirectToMainView = async () => {
            await store.dispatch('setUserOriginalData');
            await closeModal();
            if (commumAccessRoles.includes(userRole.value)) {
                if (route.name === 'My Disciplines') {
                    window.location.reload();
                    return;
                }
                router.push({ name: 'My Disciplines' });
            }
            if (managementAccessRoles.includes(userRole.value)) {
                if (route.name === 'Disciplines') {
                    window.location.reload();
                    return;
                }
                router.push({ name: 'Disciplines' });
            }
            if (userRole.value === 'admin') {
                const envKey = process?.env?.VUE_APP;
                if (envKey !== 'localhost') {
                    window.location.href = 'https://orbi.orbiedtech.app/login';
                    return;
                }
                window.location.href = 'http://app.localhost:8080/login';
            }
        };
        const closeModal = () => {
            store.dispatch('clearModalData');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", { class: "modal-body" }, [
                            _createElementVNode("div", { class: "d-flex justify-content-end" }, [
                                _createElementVNode("button", { class: "border-0 bg-transparent" }, [
                                    _createElementVNode("i", {
                                        onClick: closeModal,
                                        class: "closeModalButton bi bi-x-lg s"
                                    })
                                ])
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "px-sm-5 fw-bold mb-0 text-center" }, "Você está saindo do modo \"acessar como\", o que deseja fazer agora?", -1))
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                onClick: _withModifiers(returnToLogin, ["stop"]),
                                class: "redirectToLoginButton btn btn-primary"
                            }, "Voltar para o Login"),
                            _createElementVNode("button", {
                                onClick: _withModifiers(redirectToMainView, ["stop"]),
                                class: "redirectToInitialPageButton btn btn-primary"
                            }, "Voltar para o Início")
                        ])
                    ])
                ])
            ]));
        };
    }
});
